import { Theme, withStyles, WithStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    filterWrapper: {
      display: 'flex',
      alignItems: 'center',
      textTransform: 'none'
    },
    subheadingWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: '0.5rem'
    },
    status: {
      fontSize: '12px',
      textTransform: 'none',
      marginTop: '4px'
    }
  });

interface ISubheadingBarOwnProps extends WithStyles<typeof styles> {
  title: string;
  loading?: boolean;
  lastFetched?: string;
}

const SubheadingBarVariantTwo: React.FC<ISubheadingBarOwnProps> = ({
  classes,
  title,
  loading,
  lastFetched
}) => {
  return (
    <div className={classes.subheadingWrapper}>
      <div className={classes.filterWrapper}>{title}</div>
      <Typography className={classes.status}>
        {loading ? 'Loading...' : `Last refreshed at ${lastFetched}`}
      </Typography>
    </div>
  );
};

export default withStyles(styles)(SubheadingBarVariantTwo);
